import { useEffect, useMemo, useState } from "react"
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import _ from "underscore";
import { useLocation } from "react-router-dom";
import { callautopopulate } from "../../../services/callautopop";

export const useSprintWeek = () => {
    const [html, setHtml] = useState('');
    const [dropdown, setDropdown] = useState([])
    const [dropdownData, setDropdownData] = useState([])
    const today = new Date();
    const location = useLocation().state;

    // conditions based on sprint or week
    useEffect(() => {
            if (location?.key === 's') {
                callautopopulate("sprint").then(res => {
                    setDropdown(_.where(res?.sprint, { project_id: location.project_id }))
                })
            }
            else {
                callautopopulate("week_calendar").then(res => {
                    const weekData = res?.week_calendar;
                    const firstDayOfYear = new Date(today.getFullYear(), 0, 1);
                    const pastDaysOfYear = (today - firstDayOfYear) / 86400000;
                    const weekNumber = Math.ceil((pastDaysOfYear + firstDayOfYear.getDay() + 1) / 7);
                    const filteredWeekData = weekData.filter(week => week.weekNumber !== weekNumber);
                    const CurrentWeek = _.findWhere(weekData, { weekNumber: weekNumber });
                    filteredWeekData.unshift(CurrentWeek);
                    setDropdown(filteredWeekData)
                })
            }
    }, []);

    // get html of report
    const handleDropdownChange = async (event) => {
        let payload;
        setDropdownData(event)
        if (event?.weekNumber) {
            payload = {
                "first_date": event.FirstDate,
                "last_date": event.LastDate,
                "project_id": location.project_id,
                "client_id": location.category_id
            }
        }
        else {
            payload = {
                "sprint_id": event.sprint_id
            }
        }
        try {
            const response = await services.getInvokeRemote('POST', event?.weekNumber ? Urls('GETPROJECTSTREAKWEEKLYREPORTDETAILS') : Urls('GETPROJECTSTREAKSPRINTDETAILS'), payload)
            if (!_.isEmpty(response)) {
                if (response?.body?.data?.sprint_Details) {
                    setHtml(response.body.data.sprint_Details[0].sprint_html);
                }
                else {
                    setHtml(response.body.data.weekly_Report_Details[0].htmlData);
                }
            }
        } catch (error) {
            console.error(error);
        }
    }

    return useMemo(() => ({
        dropdown, dropdownData, handleDropdownChange, html
    }), [dropdown, dropdownData, handleDropdownChange, html])
}